import React, { Component } from 'react';
import bindModel from '../../../common/bindModel.js';
import axios from 'axios';
import { toast } from 'react-toastify';
import $ from 'jquery';
import Select from 'react-select';

import { saveDailyTask } from '../api';
import {
    DAILY_TASK_GROUPS,
    TASK_TYPES,
    TASK_RANKS,
    FIXED_SCREEN_OPTIONS,
} from '../constants';

export default class ModalUpdateDailyTask extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dailyTask: { screenId: '' },
            previewImage: null,
            loading: false,
            screens: [],
            register: !!props.register,
        };
        this.saveDailyTask = this.saveDailyTask.bind(this);
        this.getAllScreens = this.getAllScreens.bind(this);
        this.uploadImageToS3 = this.uploadImageToS3.bind(this);
    }

    componentDidMount() {
        this.getAllScreens();
    }

    // Thay cho componentWillReceiveProps (deprecated). Sync state khi parent
    // truyền `dailyTask` mới (mở modal sửa hoặc thêm mới).
    componentDidUpdate(prevProps) {
        if (this.props.dailyTask === prevProps.dailyTask) return;
        const cur = this.props.dailyTask;
        if (cur == null) return;

        if (cur.id === "") {
            // Tạo mới — giữ nguyên payload do parent khởi tạo
            this.setState({ dailyTask: cur, register: true });
        } else {
            // Sửa — normalize các field có thể null
            this.setState({
                dailyTask: {
                    ...cur,
                    group: cur.group || "",
                    type: cur.type || "",
                    rank: cur.rank || "",
                },
                previewImage: null,
                register: false,
            });
            // Render preview icon (SVGA hay ảnh tĩnh) — thao tác DOM trực tiếp
            // giữ nguyên từ legacy do component không re-render section này.
            if (cur.image != null && cur.image.endsWith("svga")) {
                $("#show-image").children().replaceWith("<div style=\"height: 300px !important\" id=\"demoCanvas\"></div>");
                if (typeof this.loadSVGA1 === "function") this.loadSVGA1(cur.image);
            } else if (cur.image != null) {
                $("#show-image").children().replaceWith("<img alt=\"\" style=\"height: 300px !important\" src=\"" + cur.image + "\"  />");
            }
        }
    }

    getAllScreens() {
        // Endpoint screen vẫn ở legacy ikaragae — không thuộc microservice game.
        this.setState({ loading: true });
        axios.post(global.config.apiDomain + '/rest/screens/getAllScreen')
            .then(res => {
                this.setState({ screens: res.data.screenModels, loading: false });
            })
            .catch(error => {
                console.error('Lỗi khi lấy danh sách màn hình:', error);
                this.setState({ loading: false });
            });
    }

    saveDailyTask() {
        const { dailyTask, previewImage } = this.state;
        const payload = previewImage ? { ...dailyTask, image: previewImage } : { ...dailyTask };

        // Microservice `game` dùng cùng endpoint `/create-or-update` cho cả tạo
        // lẫn sửa — backend upsert theo id. Không cần phân biệt register ở client.
        this.setState({ loading: true });
        saveDailyTask(payload)
            .then(body => {
                this.setState({ loading: false });
                if (body && body.status === "OK") {
                    window.$("#modalUpdateDailyTask").modal("hide");
                    this.props.resetList(body.data);
                    toast.success(body.message || "Thành công");
                } else {
                    toast.warning((body && body.message) || "Có lỗi xảy ra");
                }
            })
            .catch(error => {
                this.setState({ loading: false });
                console.error("Error occurred:", error);
                toast.error("Lỗi server, xử lý lại nha");
            });
    }

    guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    uploadImageToS3(event) {
        const target = event.target;

        // 05Dec24 Check if the file size exceeds 1MB
        if (event.target.files[0].size > 1048576) {
            toast.error("Hình ảnh không được vượt quá dung lượng 1Mb.");
            return;
        }

        if (target.files[0].size > 10495760) {
            toast.error("Kích thước file phải dưới 10mb.");
            return;
        }
        this.setState({ loading: true });
        const bucketName = "ikara-data/avatar";
        const extension = target.files[0].name.split('.').pop().toLowerCase();
        const keyName = this.guid() + "." + extension;
        let contentType = "image/svga";
        if (extension === "png") contentType = "image/svga";
        const fileReader = new FileReader();
        fileReader.onload = function () {
            const fd = new FormData();
            fd.append('file', target.files[0]);
            fd.append('bucketName', bucketName);
            fd.append('objectKey', keyName);
            fd.append('contentType', contentType);
            $.ajax({
                url: global.config.apiDomain + '/web.UploadFile',
                data: fd,
                processData: false,
                contentType: false,
                type: 'POST',
                success: function (data) {
                    this.setState({ loading: false });
                    const previewImage = 'https://data4.ikara.co/data/minio/' + bucketName + '/' + keyName;
                    this.setState({ previewImage });
                    if (previewImage != null && (previewImage.endsWith(".svga") || previewImage.endsWith(".svg"))) {
                        $("#show-image").children().replaceWith("<div style=\"height: 300px !important\" id=\"demoCanvas\"></div>");
                        if (typeof this.loadSVGA1 === "function") this.loadSVGA1(previewImage);
                    } else {
                        $("#show-image").children().replaceWith(`<img alt="" style=\"height: 300px !important\" src=${previewImage} />`);
                    }
                    target.value = null;
                }.bind(this),
            });
        }.bind(this);
        fileReader.readAsArrayBuffer(target.files[0]);
    }

    handleScreenChange = (selectedOption) => {
        this.setState(prevState => ({
            dailyTask: {
                ...prevState.dailyTask,
                screenId: selectedOption ? selectedOption.value : ''
            }
        }));
    };

    render() {
        const model = bindModel(this);
        const { dailyTask, screens } = this.state;

        // Gộp 6 screen cố định (có handler ở buildDeepLink của microservice game)
        // với danh sách screens từ legacy endpoint.
        const options = [
            ...FIXED_SCREEN_OPTIONS,
            ...screens.map(screen => ({ value: screen.id, label: screen.id }))
        ];
        const selectedScreen = options.find(o => o.value === dailyTask.screenId) || null;

        return (
            <div>
                <div className="modal fade" id="modalUpdateDailyTask" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalCenterTitle">Cập nhật Nhiệm vụ</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {this.props.register && (
                                    <div className="row mb-2">
                                        <div className="col-3"><label>Id</label></div>
                                        <div className="col-9">
                                            <input className="form-control mb-2" {...model('dailyTask.id')} />
                                        </div>
                                    </div>
                                )}
                                <div className="row mb-2">
                                    <div className="col-3"><label>Tên</label></div>
                                    <div className="col-9">
                                        <input
                                            className="form-control mb-2"
                                            type="text"
                                            placeholder="Nhập tên nhiệm vụ"
                                            {...model('dailyTask.name')} />
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3"><label>Min level</label></div>
                                    <div className="col-9">
                                        <input
                                            className="form-control mb-2"
                                            type="number"
                                            {...model('dailyTask.minLevel')} />
                                    </div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-3"><label>Icon</label></div>
                                    <div className="col-9">
                                        <input
                                            type="file"
                                            className="custom-file-input"
                                            id="inputGroupFile03"
                                            onChange={this.uploadImageToS3}
                                        />
                                        <label className="custom-file-label ml-3 mr-3" htmlFor="inputGroupFile03">Choose file</label>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3"></div>
                                    <div id="show-image" className="col-9" style={{ maxHeight: "300px" }}>
                                        <div width={500} height={500} id="canvas"></div>
                                    </div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-3"><label>Nhập màn hình đi tới</label></div>
                                    <div className="col-9">
                                        <Select
                                            className="mb-2"
                                            name="dailyTask.screenId"
                                            options={options}
                                            value={selectedScreen}
                                            onChange={this.handleScreenChange}
                                            placeholder="Chọn ID màn hình đi tới"
                                        />
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3"><label>Icoin nhận được</label></div>
                                    <div className="col-9">
                                        <input
                                            className="form-control mb-2"
                                            type="number"
                                            placeholder="Icoin nhận được"
                                            {...model('dailyTask.bonus')} />
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3"><label>Số lượng nhiệm vụ</label></div>
                                    <div className="col-9">
                                        <input
                                            className="form-control mb-2"
                                            type="number"
                                            placeholder="Số lượng nhiệm vụ"
                                            {...model('dailyTask.requestNumber')} />
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3"><label>Id nhiệm vụ</label></div>
                                    <div className="col-9">
                                        <select className="form-control" {...model('dailyTask.group')}>
                                            <option value="">Chọn ID nhiệm vụ</option>
                                            {DAILY_TASK_GROUPS.map(g => (
                                                <option key={g} value={g}>{g}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3"><label>Type</label></div>
                                    <div className="col-9">
                                        <select className="form-control" {...model('dailyTask.type')}>
                                            <option value="">Type</option>
                                            {TASK_TYPES.map(t => (
                                                <option key={t.value} value={t.value}>{t.value}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-3"><label>Độ khó</label></div>
                                    <div className="col-9">
                                        <select className="form-control" {...model('dailyTask.rank')}>
                                            <option value="">Độ khó</option>
                                            {TASK_RANKS.map(r => (
                                                <option key={r.value} value={r.value}>{r.value}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-red" data-dismiss="modal">Hủy</button>
                                {this.state.loading ? (
                                    <button style={{ width: "120px" }} className="btn btn-red" type="button" disabled>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Xác nhận...
                                    </button>
                                ) : (
                                    <button style={{ width: "120px" }} type="button" className="btn btn-red" onClick={this.saveDailyTask}>Xác nhận</button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
